/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class ColraboCafeItem extends PureComponent {
  state = {
    likes: this.props.childProps.likes,
    isLike: this.props.childProps.isLike,
  };
  componentDidMount = () => {
    const { LinkURL } = this.props.childProps;
    const pos = LinkURL.lastIndexOf('/');
    const colSerial = LinkURL.substr(pos + 1, LinkURL.length);

    const cpos = colSerial.lastIndexOf('=');
    const cSerial = colSerial.substr(cpos + 1, colSerial.length);

    this.setState({
      colSerial,
      cSerial,
    });
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)
    return this.props.childProps.LinkURL !== nextProps.childProps.LinkURL;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    if (this.props.childProps.LinkURL !== nextProps.childProps.LinkURL) {
      const { LinkURL } = this.props.childProps;
      const pos = LinkURL.lastIndexOf('/');
      const colSerial = LinkURL.substr(pos + 1, LinkURL.length);

      const cpos = colSerial.lastIndexOf('=');
      const cSerial = colSerial.substr(cpos + 1, colSerial.length);

      this.setState({
        colSerial,
        cSerial,
      });
    }
  };
  _bannerClick = () => {
    const { history } = this.props;
    // const { idx, LinkURL, Linktarget } = this.props.childProps;
    const { colSerial } = this.state;
    //console.log(history.location.pathname)
    //console.log(colSerial)
    // let i;
    // let pos;
    if (history.location.pathname === '/store') {
      history.push(colSerial);
      //history.push('/?i=' + colSerial)
      //i = colSerial.indexOf('?')
      //const s = colSerial.substr(i + 1, colSerial.length)
      //console.log(s)
    } else {
      history.push('/' + colSerial);
      //console.log('/'+ colSerial)
      //history.push('/storeCollaboCafe?i=' + colSerial)
    }
    /*
        if(idx === 79 || idx === 80 || idx === 81 || idx === 101 || idx === 104 || idx === 127 || idx === 129) {
            if(idx === 127 || idx === 129 ) {
                history.push('/event/' + LinkURL)
            } else {
                setEventIdx(parseInt(LinkURL), 3)
            }
            
        } else if (Linktarget === '_blank'){
            window.open(LinkURL, '', '')
        } else {
            history.push(LinkURL)
        }
        */
    //const pos = LinkURL.lastIndexOf('/')
    //const colSerial = LinkURL.substr(pos+1, LinkURL.length)
    //console.log(colSerial)
  };
  _onNaver = () => {
    const { cSerial } = this.state;
    const { title } = this.props.childProps;
    const url = 'http://www.aniplustv.com/storeCollaboCafe?i=' + cSerial;
    window.open(
      'http://share.naver.com/web/shareView.nhn?url=' +
        encodeURIComponent(url) +
        '&title=' +
        encodeURIComponent(title),
      'naversharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onTwitter = () => {
    const { cSerial } = this.state;
    const { title } = this.props.childProps;
    const url = 'http://www.aniplustv.com/storeCollaboCafe?i=' + cSerial;
    window.open(
      'https://twitter.com/intent/tweet?text=[%EA%B3%B5%EC%9C%A0]%20' +
        encodeURIComponent(url) +
        '%20-%20' +
        encodeURIComponent(title ? title : document.title),
      'twittersharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onFacebook = () => {
    const { cSerial } = this.state;
    const { title } = this.props.childProps;
    const url = 'http://www.aniplustv.com/storeCollaboCafe?i=' + cSerial;
    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' +
        encodeURIComponent(url) +
        '&t=' +
        encodeURIComponent(title ? title : document.title),
      'facebooksharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
  };
  _onInstar = () => {
    const { cSerial } = this.state;
    // const {
    //   idx,
    //   bannerFile,
    //   LinkURL,
    //   Linktarget,
    //   title,
    //   comment,
    //   image,
    //   LinkUrl_M,
    //   Linktarget_M,
    //   adComIdx,
    //   pageCode,
    //   openDay,
    //   openDay1,
    // } = this.props.childProps;
    const url = 'http://www.aniplustv.com/storeCollaboCafe?i=' + cSerial;
    window.open(
      'https://plus.google.com/share?url=' + encodeURIComponent(url),
      'googleplussharedialog',
      'menubar=no,toolbar=no,resizable=yes, scrollbars=yes,height=350,width=600'
    );
  };
  _onKakao = () => {
    const { cSerial } = this.state;
    // const {
    //   idx,
    //   bannerFile,
    //   LinkURL,
    //   Linktarget,
    //   title,
    //   comment,
    //   image,
    //   LinkUrl_M,
    //   Linktarget_M,
    //   adComIdx,
    //   pageCode,
    //   openDay,
    //   openDay1,
    // } = this.props.childProps;
    const url = 'http://www.aniplustv.com/storeCollaboCafe?i=' + cSerial;
    window.open(
      'https://story.kakao.com/s/share?url=' + encodeURIComponent(url),
      'kakaostorysharedialog',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes, height=400,width=600'
    );
  };
  _goCollabo = () => {
    const { history } = this.props;
    //window.open('https://shop.aniplustv.com/collabo', '', '')
    history.push('/storeCollaboCafe');
  };
  _onLike = async () => {
    const { loginId } = this.props;
    const { likes } = this.state;

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요');
    } else {
      const result = await this._onLikeApi();
      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
        //좋아요 성공
        this.setState({
          likes: likes + 1,
          isLike: 100,
        });
      } else {
        this.setState({
          likes: likes - 1,
          isLike: 0,
        });
        //좋아요 취소
      }
    }
  };
  _onLikeApi = () => {
    const { apiUrl, loginId } = this.props;
    const { cSerial } = this.state;
    return axios
      .post(apiUrl + '/collaboLike', {
        params: {
          idx: cSerial,
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };
  render() {
    const {
      title,
      comment,
      image,

      openDay,
      pos,
      readNum,
    } = this.props.childProps;
    const { likes, isLike } = this.state;
    const { imgUrl } = this.props;

    return (
      <Fragment>
        {pos === 'cafe' ? (
          <div className="collabo_slide_item">
            {/* 카드 상단/ */}
            <div className="store_card_top">
              <span
                className="tag"
                onClick={this._goCollabo}
                style={{ cursor: 'pointer' }}
              >
                콜라보 카페
              </span>
              <ul className="store_card_top_rt">
                <li className="store_card_ico">
                  <span
                    className={isLike > 0 ? 'ico_like active' : 'ico_like'}
                    onClick={this._onLike}
                  ></span>
                  <span className="num">{likes}</span>
                </li>
                <li className="store_card_ico">
                  <span className="ico_read"></span>
                  <span className="num">{readNum}</span>
                </li>
                <li className="store_card_ico btn_more">
                  <span className="ico_more"></span>
                  <ul className="more_wrap">
                    <li>
                      <a
                        onClick={this._onFacebook}
                        style={{ cursor: 'pointer' }}
                      >
                        <img
                          src={imgUrl + '/img/store/sns_fb.png'}
                          alt="페이스북"
                        />
                      </a>
                    </li>
                    <li>
                      <a onClick={this._onKakao} style={{ cursor: 'pointer' }}>
                        <img
                          src={imgUrl + '/img/store/sns_kako.png'}
                          alt="카카오"
                        />
                      </a>
                    </li>
                    <li>
                      <a onClick={this._onInstar} style={{ cursor: 'pointer' }}>
                        <img
                          src={imgUrl + '/img/store/sns_google.png'}
                          alt="구글"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        onClick={this._onTwitter}
                        style={{ cursor: 'pointer' }}
                      >
                        <img
                          src={imgUrl + '/img/store/sns_twt.png'}
                          alt="트위터"
                        />
                      </a>
                    </li>
                    <li>
                      <a onClick={this._onNaver} style={{ cursor: 'pointer' }}>
                        <img
                          src={imgUrl + '/img/store/sns_naver.png'}
                          alt="네이버"
                        />
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            {/* 카드 타이틀/ */}
            <div className="store_card_tit" onClick={this._bannerClick}>
              <p className="date">
                <span>{openDay}</span>
              </p>
              <p className="tit">{title}</p>
              <p
                className="summary"
                dangerouslySetInnerHTML={{ __html: comment }}
              ></p>
            </div>
            {/* 카드 썸네일/ */}
            <div className="store_card_thumb" onClick={this._bannerClick}>
              <img src={image} />
            </div>
          </div>
        ) : (
          //메인
          <div className="inner_item">
            {/* 카드 내용 (콜라보 카페 cafe, 서울 합정점 su_hj, 대전 중앙로점 dj_ja, 광주 충장로점 gj_cj, 부산 서면점 bs_sm) / */}
            <div className="store_card cafe">
              {/* 카드 상단/ */}
              <div className="store_card_top">
                <span
                  className="tag"
                  onClick={this._goCollabo}
                  style={{ cursor: 'pointer' }}
                >
                  콜라보 카페
                </span>
                <ul className="store_card_top_rt">
                  <li className="store_card_ico">
                    <span
                      className={isLike > 0 ? 'ico_like active' : 'ico_like'}
                      onClick={this._onLike}
                    ></span>
                    <span className="num">{likes}</span>
                  </li>
                  <li className="store_card_ico">
                    <span className="ico_read"></span>
                    <span className="num">{readNum}</span>
                  </li>

                  <li className="store_card_ico btn_more">
                    <span className="ico_more"></span>
                    <ul className="more_wrap">
                      <li>
                        <a
                          onClick={this._onFacebook}
                          style={{ cursor: 'pointer' }}
                        >
                          <img
                            src={imgUrl + '/img/store/sns_fb.png'}
                            alt="페이스북"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={this._onKakao}
                          style={{ cursor: 'pointer' }}
                        >
                          <img
                            src={imgUrl + '/img/store/sns_kako.png'}
                            alt="카카오"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={this._onInstar}
                          style={{ cursor: 'pointer' }}
                        >
                          <img
                            src={imgUrl + '/img/store/sns_google.png'}
                            alt="구글"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={this._onTwitter}
                          style={{ cursor: 'pointer' }}
                        >
                          <img
                            src={imgUrl + '/img/store/sns_twt.png'}
                            alt="트위터"
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={this._onNaver}
                          style={{ cursor: 'pointer' }}
                        >
                          <img
                            src={imgUrl + '/img/store/sns_naver.png'}
                            alt="네이버"
                          />
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
              {/* 카드 타이틀/ */}
              <div className="store_card_tit" onClick={this._bannerClick}>
                <p className="date">
                  <span>{openDay}</span>
                </p>
                <p className="tit">{title}</p>
                <p
                  className="summary"
                  dangerouslySetInnerHTML={{ __html: comment }}
                ></p>
              </div>
              {/* 카드 썸네일/ */}
              <div className="store_card_thumb" onClick={this._bannerClick}>
                <img src={image} />
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(ColraboCafeItem)));
